import { render, staticRenderFns } from "./FormElementComponent.vue?vue&type=template&id=470d109c&scoped=true"
import script from "./FormElementComponent.vue?vue&type=script&lang=js"
export * from "./FormElementComponent.vue?vue&type=script&lang=js"
import style0 from "./FormElementComponent.vue?vue&type=style&index=0&id=470d109c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d109c",
  null
  
)

export default component.exports